<template>
  <div class="grid">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#274461"
      :is-full-page="fullPage"
    ></loading>
    <div class="col-12">
      <div class="card">
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems">
                <!--<template #item="{ item, props }">
                    <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
                        <a :href="href" v-bind="props.action" @click="navigate">
                            <span :class="[item.icon, 'text-color']" />
                            <span class="text-primary font-semibold">{{ item.label }}</span>
                        </a>
                    </router-link>
                </template>-->
            </Breadcrumb>
        <Toast />
        <Toolbar class="mb-4">
          <template v-slot:start>
            <div class="my-2">
              <span class="p-float-label">
              <InputText  format="number"  v-model="reg_number" @keypress="isNumber($event)" > </InputText>
              <label>Registration Number</label>
                &nbsp;
                <Button
                  icon="pi pi-search"
                  v-tooltip.bottom="'Search'"
                  @click="search(1)"
                /></span>
              <!-- <Button
                  label="Delete"
                  icon="pi pi-trash"
                  class="p-button-danger"
                  @click="confirmDeleteSelected"
                  :disabled="!selectedProducts || !selectedProducts.length"
                /> -->
              <!-- &nbsp;
                <Button
                  icon="pi pi-sync"
                  class="p-button-info mr-2"
                  @click="get_list"
                /> -->
            </div>
          </template>

          <template v-slot:end>
            <Button
                
                icon="pi pi-plus"
                v-tooltip.bottom="'Add'"
                @click="openNew"
              />
            <!-- <FileUpload
                mode="basic"
                accept="image/*"
                :maxFileSize="1000000"
                label="Import"
                chooseLabel="Import"
                class="mr-2 inline-block"
              /> -->
            <!-- <json-excel :data="product"> -->
            <!-- <Button
                label="Export"
                icon="pi pi-upload"
                class="p-button-help"
               @click="exportCSV"
              /> -->
            <!-- </json-excel> -->
          </template>
        </Toolbar>

        <DataTable
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="products"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25, totalRecords]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true"
          showGridlines
        >
          <template #empty>
            <b style="text-align: center">No records found.</b>
          </template>
          <template #header>
            <div
              class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
            >
              <h5 class="m-0"><b> Hire Vehicle List</b></h5>
              <!-- Total Records:{{ totalRecords }} -->

              <Button icon="pi pi-refresh" v-tooltip.bottom="'Refresh'" @click="search(2)" />
              <!-- <span class="block mt-2 md:mt-0 p-input-icon-left">
                                  <i class="pi pi-search" />
                                  <InputText v-model="filters['global'].value" placeholder="Search..." />
                              </span> -->
            </div><div style="text-align:right;font-weight:bold"><span>Total Hire Vehicles:</span>{{totalRecords}}</div>
          </template>

          <!-- <Column v-for="(col,index) in columns" :field="col" :header="col.toUpperCase()" :key="index"></Column> -->
          <!-- <Column selectionMode="multiple" headerStyle="width: 3rem"></Column> -->

          <!-- <Column
            header="Status"
            style="min-width: 8rem; text-align: center"
            :field="columns[14]"
          >
            <template #body="{ data }">
              <span v-if="data.status == 'Active' || data.status == 'active'"
                ><badge :value="data.status" severity="success"></badge
              ></span>
              <span
                v-else-if="
                  data.status == 'InActive' || data.status == 'In Active'
                "
                ><badge :value="data.status" severity="warning"></badge
              ></span>
              <span
                v-else-if="data.status == 'Delete' || data.status == 'Deleted'"
                ><badge :value="data.status" severity="danger"></badge
              ></span>
              <span v-else>-</span>
            </template>
          </Column> -->

          <Column header="Sr No" style="min-width: 5rem; text-align: center">
            <template #body="{ index }">
              <span v-if="page_no == 1">{{ +index + +1 }}</span>
              <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
            </template>
          </Column>

          <Column
            header="Registration Number"
            :field="columns[9]"
            style="text-align: right"
          >
            <template #body="{ data }">
              {{ data.registration_number }}
            </template>
          </Column>
          <Column header="Mobile Number RC" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.mobile_number_rc }}
            </template>
          </Column>

          <Column
            header="RC Number"
            :field="columns[3]"
            style="min-width: 5rem"
          >
            <template #body="{ data }">
              {{ data.rc_number }}
            </template>
          </Column>

          <Column header="PUC Validity" :field="columns[10]">
            <template #body="{ data }">
              {{ dateFormat(data.puc_validity) }}
            </template>
          </Column>
          <Column header="Insurance Validity" :field="columns[10]">
            <template #body="{ data }">
              {{ dateFormat(data.insurance_validity) }}
            </template>
          </Column>

          <Column header="Owner Name" :field="columns[10]">
            <template #body="{ data }">
              {{ data.owner_name }}
            </template>
          </Column>
          <Column header="Owner Mobile Number" :field="columns[10]">
            <template #body="{ data }">
              {{ data.owner_mobile_number }}
            </template>
          </Column>
          <Column header="Driver Name" :field="columns[10]">
            <template #body="{ data }">
              {{ data.driver_name }}
            </template>
          </Column>
          <Column header="Driver Mobile Number" :field="columns[10]">
            <template #body="{ data }">
              {{ data.driver_mobile_number }}
            </template>
          </Column>
          <Column header="Action" headerStyle="min-width:5rem;">
            <template #body="slotProps">
              <!-- <Button
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-success mr-2"
                  @click="editProduct(slotProps.data)"
                /> -->
              <!-- <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning mr-2"
                @click="confirmDeleteProduct(slotProps.data)"
              /> -->
              <!-- <Button
                  icon="pi pi-bookmark"
                  class="p-button-rounded p-button-primary mt-2"
                  @click="showQr(slotProps.data)"
                /> -->
            </template>
          </Column>
        </DataTable>

        <Dialog
          v-model:visible="deleteProductDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
        <div class="p-fluid formgrid grid">
            <div class="field col-12 md:col-12">
                    <label for="Route">Select Route</label>
                    <Dropdown
                      id="Route"
                      v-model="selectstatus"
                      :options="dropdownItems"
                      :value="dropdownItems.value"
                      optionLabel="name"
                      placeholder="Select One"
                      :class="{ 'p-invalid': submitted && !selectstatus }"
                      required="true"
                    ></Dropdown>
                  </div>

           
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteProductDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteuser"
            />
          </template>
        </Dialog>

        <Dialog
          v-model:visible="deleteProductsDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="product"
              >Are you sure you want to delete the selected products?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteProductsDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteSelectedProducts"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import JsonExcel from "vue-json-excel";
import BreadcrumbService from "../service/BreadcrumbService";

//import FormNewsMaster from "@/components/FormNewsMaster";
//import * as Survey from "survey-vue";

// import axios from "axios";
import apis from "@/apis";
import axios from "axios";

export default {
  data() {
    return {
      reg_number:'',
      page_no: 1,
      qrcodevalue: "123444",
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      qrCodetDialog: false,
      file_attachment: "",

      dropdownItems: [],
      products: null,
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      route_list:[],
      selectedProducts: null,
      filters: {},
      offset: 1,
      selectstatus: null,
      // selectstatus2: { name: "Motivational", value: "Motivational" },
      limit: 10,
      columns: [],
      head: [
        "Data Usages",
        "Network Connectivity",
        "Students",
        "Teachers",
        "Student Registration",
        "News Master",
        "Government Panel",
        "Feedback Master",
        "User Queries",
        "Schemes Master",
        "Notice Master",
        "Subject Master",
        "Teacher Schedule Master",
        "Teacher Schedule DE Master",
        "Query Types Master",
        "Sub Query Types Master",
        "Admin Users",
        "Application Roles",
        "Departments",
        "Cast Master",
        "Year Master",
        "District Master",
        "Student Attendance",
        "Student Document",
        "Teachers",
        "Radical ids",
        "Subject Topics",
        "Query Comments",
        "Student Submit Answers",
        "Mock Tests",
        "Mock Test Papers",
        "Mock Test Results",
        "Video",
        "Syllabus",
        "Course",
      ],
      pageno: 1,
      submitted: false,
      totalRecords: 0,
      id: "",
      statuses: [
        { label: "INSTOCK", value: "instock" },
        { label: "LOWSTOCK", value: "lowstock" },
        { label: "OUTOFSTOCK", value: "outofstock" },
      ],
      BreadcrumbService : null,
      breadcrumbHome: {},
      breadcrumbItems: [],
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();

    this.BreadcrumbService = new BreadcrumbService();
	let Breadcrum_data = this.BreadcrumbService.hire_vehicle_master()
	this.breadcrumbHome=Breadcrum_data.home;
	this.breadcrumbItems=Breadcrum_data.items;
  },
  async mounted() {
    // this.productService.getProducts().then(data => this.products = data);
    this.id = this.$route.params.id;

    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
    //alert(this.id);
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  methods: {
    isNumber(evt) {  
      const charCode = evt.which ? evt.which : evt.keyCode;  
      if (  
        charCode > 31 &&  
        (charCode < 48 || charCode > 57) &&  
        charCode !== 46  
      ) {  
        evt.preventDefault();  
      }  
    },
    async search(count)
      { 
        
        count==2?this.reg_number='':'';
        await this.get_list();
        await this.get_count();
      },
    //a simple date formatting function
    dateFormat(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == "NaN-NaN-NaN") {
          return postdate;
        } else {
          let date = ("0" + inputDate.getDate()).slice(-2);

          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == "aN") {
            return postdate;
          } else {
            return date + "-" + month + "-" + year;
          }
        }
      } else {
        return "";
      }
    },

    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // console.log(event);
      //  await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var data = {
   
        count: true,
        client_id: localStorage.getItem("client_id"),
        registration_number:this.reg_number
        
      };
      this.loading = true;
      var promise = apis.HireVehicleList(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.totalRecords = response.data.data;
        //alert(this.totalRecords);
      });

      console.log(data);
    },
    get_list: function () {
      var data = {
       
        client_id: localStorage.getItem("client_id"),
        limit: this.limit,
        page_no: this.page_no,
        count: false,
        registration_number:this.reg_number
        
      };
      this.loading = true;
      var promise = apis.HireVehicleList(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });

      console.log(data);
    },
    formatCurrency(value) {
      if (value)
        return value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
      return;
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      // this.productDialog = true;
      this.$router.push({ name: "hire_vehicle" });
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },

    async editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.productDialog = true;
      // this.selectstatus.value = this.product.status;
      // this.selectstatus.name = this.product.status;

      await localStorage.setItem("savevehicledata", "");
      await localStorage.setItem("savevehicledata", JSON.stringify(product));
      this.$router.push({ name: "vehicle_add" });
    },
    confirmDeleteProduct(product) {
      this.product = product;
     
      if (this.product.group_ids.length>0) {
        var data=[];
        for (let x = 0; x < this.product.group_ids.length; x++) 
        {
        
          data.push({name:this.product.group_name[x],value:this.product.group_ids[x]});
        }
        console.log(data);
        this.dropdownItems=data;
        
        
      }

      this.deleteProductDialog = true;
    },

    deleteProduct() {
      this.products = this.products.filter((val) => val.id !== this.product.id);
      this.deleteProductDialog = false;
      this.product = {};
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Product Deleted",
        life: 3000,
      });
    },

    deleteuser() {
     
      if (this.product._id) {
        var data = {
          vehicle_id:this.product.vahicle_id,
          group_id: this.selectstatus.value,
          
          updated_by:localStorage.getItem("id")
        };
        this.isLoadingModel = true;
        var promise = apis.delete_hire_vehicle(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            // this.hideDialog1();
            this.deleteProductDialog = false;
            this.$swal(responseapi.data.message);
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Video");
          }
        });
      }
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },

    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteProductsDialog = true;
    },
    deleteSelectedProducts() {
      this.products = this.products.filter(
        (val) => !this.selectedProducts.includes(val)
      );
      this.deleteProductsDialog = false;
      this.selectedProducts = null;
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Products Deleted",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: { downloadExcel: JsonExcel },
};
</script>

<style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>
